import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { required, maxLength, multiEmail } from '@src/validation';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';

const fieldValidator = {
  name: [required, value => maxLength(value, 255)],
  contact_name: [value => maxLength(value, 255)],
  phone: [value => maxLength(value, 64)],
  email: [value => maxLength(value, 255), multiEmail],
  fax: [value => maxLength(value, 64)],
  address_line_1: [value => maxLength(value, 255)],
  address_line_2: [value => maxLength(value, 255)],
  city: [value => maxLength(value, 255)],
  state: [value => maxLength(value, 64)],
  zip_code: [value => maxLength(value, 32)]
};
class DeveloperModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value:
          props.entity[key] !== undefined && props.entity[key] !== null
            ? props.entity[key]
            : '',
        visited: false,
        error: false
      };
    });

    this.state = { ...fields };
  }

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      if (
        this.props.entity !== undefined &&
        this.props.entity.id !== undefined
      ) {
        this.props.onEdit(this.props.entity.id, postData, () =>
          this.props.toggle()
        );
      } else {
        this.props.onCreate(postData, this.props.history);
      }
    }
    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.entity.id !== undefined
              ? 'Edit Developer'
              : 'Create New Developer'}
          </ModalHeader>
          <div className={'position-relative'}>
            <ModalBody className={'p-4'}>
              <Row>
                <Col>
                  <LabelInput
                    name={'Name'}
                    type={'text'}
                    required={true}
                    {...this.state.name}
                    onChange={event => this.updateForm(event, 'name')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'Contact Name'}
                    type={'text'}
                    {...this.state.contact_name}
                    onChange={event => this.updateForm(event, 'contact_name')}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabelInput
                    name={'Email (Separate emails with a comma)'}
                    type={'text'}
                    {...this.state.email}
                    onChange={event => this.updateForm(event, 'email')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'Phone'}
                    type={'text'}
                    {...this.state.phone}
                    onChange={event => this.updateForm(event, 'phone')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'Fax'}
                    type={'text'}
                    {...this.state.fax}
                    onChange={event => this.updateForm(event, 'fax')}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabelInput
                    name={'Address Line 1'}
                    type={'text'}
                    {...this.state.address_line_1}
                    onChange={event => this.updateForm(event, 'address_line_1')}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <LabelInput
                    name={'Address Line 2'}
                    type={'text'}
                    {...this.state.address_line_2}
                    onChange={event => this.updateForm(event, 'address_line_2')}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <LabelInput
                    name={'City'}
                    type={'text'}
                    {...this.state.city}
                    onChange={event => this.updateForm(event, 'city')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'State'}
                    type={'text'}
                    {...this.state.state}
                    onChange={event => this.updateForm(event, 'state')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'Zip Code'}
                    type={'text'}
                    {...this.state.zip_code}
                    onChange={event => this.updateForm(event, 'zip_code')}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}

const mapStateToProps = state => {
  return {
    loading: state.developer.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCreate: (postData, history) =>
      dispatch(actions.createDeveloper(postData, history)),
    onEdit: (entityId, postData, callback) =>
      dispatch(actions.editDeveloper(entityId, postData, callback))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeveloperModal);
